import Vue from 'vue'
import Router from 'vue-router'
import auth from "@/auth/authService";

// import firebase from 'firebase/app'
// import 'firebase/auth'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                {
                    path: '/',
                    redirect: '/dashboard'
                },
                {
                    path: '/dashboard',
                    name: 'dashboard',
                    component: () => import('./views/apps/dashboard/Dashboard.vue'),
                    meta: {
                        needAuth: true,
                        pageTitle: 'Dashboard',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/packages',
                    name: 'packages',
                    component: () => import('./views/apps/package/AllPackages.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Packages', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Packages',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/packages/add',
                    name: 'add-package',
                    component: () => import('./views/apps/package/AddPackages.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Packages', url:'/packages'},
                            { title: 'Add Package', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Add Package',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/packages/view/:packageId',
                    name: 'view-package',
                    component: () => import('./views/apps/package/ViewPackages.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Packages', url:'/packages'},
                            { title: 'View Package', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'View Package',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/packages/edit/:packageId',
                    name: 'edit-package',
                    component: () => import('./views/apps/package/EditPackages.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Packages', url:'/packages'},
                            { title: 'Edit Package', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Edit Package',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/modules',
                    name: 'modules',
                    component: () => import('./views/apps/module/AllModules.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'All Modules', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Modules',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/modules/add',
                    name: 'add-module',
                    component: () => import('./views/apps/module/AddModule.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Modules', url:'/modules'},
                            { title: 'Add Module', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Add Module',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/modules/view/:moduleId',
                    name: 'view-module',
                    component: () => import('./views/apps/module/ViewModules.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Modules', url:'/modules'},
                            { title: 'View Module', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'View Modules',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/modules/edit/:moduleId',
                    name: 'edit-module',
                    component: () => import('./views/apps/module/EditModules.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Modules', url:'/modules'},
                            { title: 'Edit Module', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Edit Module',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/modules/add',
                    name: 'add-modules',
                    component: () => import('./views/DashboardAnalytics.vue'),
                    meta: {
                        needAuth: true,
                        pageTitle: 'Add Module',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/teachers',
                    name: 'teachers',
                    component: () => import('./views/apps/teacher/teacher-list/TeacherList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Teachers', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Teachers',
                        roles: ['admin'],
                        permissions: ['view_favorites'],
                    }
                },
                {
                    path: '/teachers/add',
                    name: 'add-teachers',
                    component: () => import('./views/apps/teacher/teacher-add/TeacherAdd.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Add Teacher', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Add Teacher',
                        roles: ['admin'],
                        permissions: ['view_favorites'],
                    }
                },
                {
                    path: '/teachers/:teacherId',
                    name: 'teachers-view',
                    component: () => import('./views/apps/teacher/teacher-edit/TeacherEdit.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Teachers', url:'/teachers'},
                            { title: 'Teacher Details', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Teachers',
                        roles: ['admin'],
                        permissions: ['view_favorites'],
                    }
                },
                {
                    path: '/students',
                    name: 'students',
                    component: () => import('./views/apps/student/student-list/StudentList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Students', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Students',
                        roles: ['admin'],
                        permissions: ['view_favorites'],
                    }
                },
                {
                    path: '/students/add',
                    name: 'add-students',
                    component: () => import('./views/apps/student/student-add/StudentAdd.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Add Student', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Add Student',
                        roles: ['admin'],
                        permissions: ['view_favorites'],
                    }
                },
                {
                    path: '/students/:studentId',
                    name: 'students-view',
                    component: () => import('./views/apps/student/student-edit/StudentEdit.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Students', url:'/students'},
                            { title: 'Student Details', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Students',
                        roles: ['admin'],
                        permissions: ['view_favorites'],
                    }
                },
                {
                    path: '/settings',
                    name: 'settings',
                    component: () => import('@/views/apps/settings/UserSettings.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Settings', active: true },
                        ],
                        pageTitle: 'Settings',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/receipts',
                    name: 'receipts',
                    component: () => import('@/views/apps/receipts/AllReceipts.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Kvitteringer', active: true },
                        ],
                        pageTitle: 'Kvitteringer',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/theoryrating',
                    name: 'theoryrating',
                    component: () => import('@/views/apps/theoryrating/TheoryRating.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Theory Rating', active: true },
                        ],
                        pageTitle: 'Theory Rating',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/theoryrating/:ratingId',
                    name: 'theoryrating-view',
                    component: () => import('./views/apps/theoryrating/TheoryRatingView.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Theory Rating', url:'/theoryrating'},
                            { title: 'Theory Rating Details', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Theory Rating Detail',
                        roles: ['admin'],
                        permissions: ['view_favorites'],
                    }
                },
                {
                    path: '/manoeuvrerating',
                    name: 'manoeuvrerating',
                    component: () => import('@/views/apps/manoeuvrerating/ManoeuvreRating.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Manoeuvre Rating', active: true },
                        ],
                        pageTitle: 'Manoeuvre Rating',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/manoeuvrerating/:ratingId',
                    name: 'manoeuvrerating-view',
                    component: () => import('./views/apps/manoeuvrerating/ManoeuvreRatingView.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Manoeuvre Rating', url:'/manoeuvrerating'},
                            { title: 'Manoeuvre Rating Details', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Manoeuvre Rating Detail',
                        roles: ['admin'],
                        permissions: ['view_favorites'],
                    }
                },
                {
                    path: '/lessonsrating',
                    name: 'lessonsrating',
                    component: () => import('@/views/apps/lessonsrating/LessonsRating.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Lessons Rating', active: true },
                        ],
                        pageTitle: 'Lessons Rating',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/lessonsrating/:ratingId',
                    name: 'lessonsrating-view',
                    component: () => import('./views/apps/lessonsrating/LessonsRatingView.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Lessons Rating', url:'/lessonsrating'},
                            { title: 'Lessons Rating Details', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Lessons Rating Detail',
                        roles: ['admin'],
                        permissions: ['view_favorites'],
                    }
                },
                {
                    path: '/slipperyrating',
                    name: 'slipperyrating',
                    component: () => import('@/views/apps/slipperyrating/SlipperyRating.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Slippery Rating', active: true },
                        ],
                        pageTitle: 'Slippery Rating',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/slipperyrating/:ratingId',
                    name: 'slipperyrating-view',
                    component: () => import('./views/apps/slipperyrating/SlipperyRatingView.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Slippery Rating', url:'/slipperyrating'},
                            { title: 'Slippery Rating Details', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Slippery Rating Detail',
                        roles: ['admin'],
                        permissions: ['view_favorites'],
                    }
                },
                {
                    path: '/theoryratingtranslation',
                    name: 'theoryratingtranslation',
                    component: () => import('@/views/apps/theoryrating/TheoryRatingTranslation.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Theory Rating Translation', active: true },
                        ],
                        pageTitle: 'Theory Rating Translation',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/manoeuvreratingtranslation',
                    name: 'manoeuvreratingtranslation',
                    component: () => import('@/views/apps/manoeuvrerating/ManoeuvreRatingTranslation.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Manoeuvre Rating Translation', active: true },
                        ],
                        pageTitle: 'Manoeuvre Rating Translation',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/lessonsratingtranslation',
                    name: 'lessonsratingtranslation',
                    component: () => import('@/views/apps/lessonsrating/LessonsRatingTranslation.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Lessons Rating Translation', active: true },
                        ],
                        pageTitle: 'Lessons Rating Translation',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/slipperyratingtranslation',
                    name: 'slipperyratingtranslation',
                    component: () => import('@/views/apps/slipperyrating/SlipperyRatingTranslation.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Slippery Rating Translation', active: true },
                        ],
                        pageTitle: 'Slippery Rating Translation',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/learninghubcategories',
                    name: 'learninghubcategories',
                    component: () => import('@/views/apps/learninghub/Categories.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Learning Hub Categories', active: true },
                        ],
                        pageTitle: 'Learning Hub Categories',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/learninghubcategories/add',
                    name: 'addlearninghubcategories',
                    component: () => import('@/views/apps/learninghub/AddCategory.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Add Category', active: true },
                        ],
                        pageTitle: 'Add Category',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/learninghubcategories/edit/:id',
                    name: 'editlearninghubcategories',
                    component: () => import('@/views/apps/learninghub/EditCategory.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Edit Category', active: true },
                        ],
                        pageTitle: 'Edit Category',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/learninghubcategories/delete/:id',
                    name: 'deletelearninghubcategories',
                    component: () => import('@/views/apps/learninghub/DeleteCategory.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Delete Category', active: true },
                        ],
                        pageTitle: 'Delete Category',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/learninghublisting',
                    name: 'learninghublisting',
                    component: () => import('@/views/apps/learninghub/LearningHub.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Learning Hub List', active: true },
                        ],
                        pageTitle: 'Learning Hub List',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/learninghublisting/add',
                    name: 'addlearninghublisting',
                    component: () => import('@/views/apps/learninghub/AddLearningHub.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Add Learning Hub', active: true },
                        ],
                        pageTitle: 'Add Learning Hub',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/learninghublisting/edit/:id',
                    name: 'editlearninghublisting',
                    component: () => import('@/views/apps/learninghub/EditLearningHub.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Edit Learning Hub', active: true },
                        ],
                        pageTitle: 'Edit Learning Hub',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/learninghublisting/delete/:id',
                    name: 'deletelearninghublisting',
                    component: () => import('@/views/apps/learninghub/DeleteLearningHub.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Delete Learning Hub', active: true },
                        ],
                        pageTitle: 'Delete Learning Hub',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                }
                
            ],
        },
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
                {
                    path: '/login',
                    name: 'page-login',
                    component: () => import('@/views/apps/auth/Login.vue'),
                    meta: {

                    }
                },
                 {
                     path: '/register',
                     name: 'page-register',
                     component: () => import('@/views/apps/auth/Register.vue'),
                     meta: {

                     }
                 },
                {
                    path: '/forgot-password',
                    name: 'page-forgot-password',
                    component: () => import('@/views/apps/auth/ForgotPassword.vue'),
                    meta: {

                    }
                },
                // {
                //     path: '/reset-password',
                //     name: 'page-reset-password',
                //     component: () => import('@/views/apps/auth/ResetPassword.vue'),
                //     meta: {

                //     }
                // },
                // {
                //     path: '/pages/lock-screen',
                //     name: 'page-lock-screen',
                //     component: () => import('@/views/apps/auth/LockScreen.vue'),
                //     meta: {

                //     }
                // },
                // {
                //     path: '/error-404',
                //     name: 'page-error-404',
                //     component: () => import('@/views/apps/auth/Error404.vue'),
                //     meta: {
   
                //     }
                // },
                // {
                //     path: '/not-authorized',
                //     name: 'page-not-authorized',
                //     component: () => import('@/views/apps/auth/NotAuthorized.vue'),
                //     meta: {
           
                //     }
                // },
            ]
        },
        {
            path: '*',
            redirect: '/error-404'
        }
    ],
})

router.beforeEach((to, from, next) => {
    const user = JSON.parse(localStorage.getItem("userInfo"))
    const needAuth = to.meta.needAuth ? to.meta.needAuth : false;

    if(needAuth) {
        if(to.meta.roles && to.meta.roles.length && user){
            let response = false
            let returnResponse = false
            let roles = to.meta.roles
            
            for (var index = 0; index < roles.length; ++index) {
                response = user.roles.includes(roles[index])
                if(response) returnResponse = true;
            }
            
            if(returnResponse) next()
            else return next({ path: '/not-authorized' });
        }
        else next({ path: '/login' });
    }

    next()
})

router.afterEach(() => {
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

export default router

